import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>Terms of Service</h1>
      
      <section className="terms-usage">
        <h2>Usage Rights</h2>
        <p>
          By using NeuLogic<span style={tmStyle}>™</span> software tools, you agree to use them for lawful purposes only. You agree not to reverse engineer, decompile, disassemble, redistribute, or resell the software without explicit written permission. All software is provided "as is" without warranty of any kind, though we strive to ensure a high-quality experience.
        </p>
      </section>
      
      <section className="terms-licensing">
        <h2>Licensing</h2>
        <p>
          You may use evaluation versions of our software for personal or professional productivity for the specified trial period. Purchasing a license grants you the right to use the full version according to the specific license terms provided at the time of purchase (single-user, multi-user, or site license).
        </p>
        <p>
          Your license is non-transferable and does not constitute ownership of the software, only the right to use it according to these terms.
        </p>
      </section>
      
      <section className="terms-updates">
        <h2>Updates and Support</h2>
        <p>
          Access to updates and technical support may vary.
        </p>
      </section>
      
      <section className="terms-contact">
        <h2>Contact</h2>
        <p>
          For questions about these terms or our software, please contact <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}